export enum EMenuCommand {
  ToggleImageHeading,
  ToggleImageCaption,
  ReplaceImage,
}
